import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Transition as _Transition, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/mono.svg'
import _imports_1 from '@/assets/llama.svg'


const _hoisted_1 = { class: "has-navbar-fixed-top-touch" }
const _hoisted_2 = {
  class: "navbar is-tp-navbar is-fixed-top is-hidden-desktop",
  role: "navigation",
  "aria-label": "main navigation"
}
const _hoisted_3 = { class: "navbar-brand" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-item",
  href: "/"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Teleperformance Logo"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1)
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "columns is-gapless is-tp-columns-root" }
const _hoisted_10 = { class: "column is-narrow is-hidden-touch is-tp-menu-column" }
const _hoisted_11 = { class: "column-fixed-flex" }
const _hoisted_12 = { class: "menu is-tp-menu" }
const _hoisted_13 = { class: "menu-label is-tp-menu-logo" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  class: "is-tp-menu-logo-img",
  src: _imports_0,
  alt: "Teleperformance Logo"
}, null, -1)
const _hoisted_15 = { class: "menu-list" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "menu-label" }, "Logs", -1)
const _hoisted_19 = { class: "menu-list" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "column is-narrow" }
const _hoisted_23 = { class: "image is-48x48" }
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  key: 1,
  class: "is-squircle nophoto",
  src: _imports_1,
  alt: "Logout Image"
}
const _hoisted_26 = { class: "column is-tp-content-column" }
const _hoisted_27 = { class: "is-tall" }
const _hoisted_28 = { class: "footer is-tp-footer is-tp-container" }
const _hoisted_29 = { class: "columns" }
const _hoisted_30 = { class: "column pb-1 is-narrow" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "column pb-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "tag is-danger is-light has-text-weight-semibold" }, "Teleperformance Restricted")
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "is-hidden-desktop is-tp-footer-spacer" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_beta = _resolveComponent("beta")!
  const _component_userModal = _resolveComponent("userModal")!
  const _component_navigation_modal = _resolveComponent("navigation-modal")!
  const _component_lazy = _resolveComponent("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.allowed)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("nav", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("a", {
                role: "button",
                id: "hamburger",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hamburgerHelper && _ctx.hamburgerHelper(...args))),
                class: "navbar-burger burger ladida",
                "aria-label": "menu",
                "aria-expanded": "false",
                "data-target": "navbar-menu"
              }, _hoisted_8)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("aside", _hoisted_12, [
                  _createElementVNode("p", _hoisted_13, [
                    _createVNode(_component_router_link, { to: "/" }, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("ul", _hoisted_15, [
                    (_ctx.isAllowed('App.Manage'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                          _createVNode(_component_router_link, {
                            "active-class": "is-active",
                            to: {name: 'AdminHome'}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Applications")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isAllowed('AllowedDomain.Manage'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                          _createVNode(_component_router_link, {
                            "active-class": "is-active mt-3",
                            to: {name: 'AdminAllowedDomains'}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Allowed domains")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_18,
                  _createElementVNode("ul", _hoisted_19, [
                    (_ctx.isAllowed('log.read'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                          _createVNode(_component_router_link, {
                            "active-class": "is-active mt-3",
                            to: {name: 'LogsRecords'}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Log records")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isAllowed('log.read'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                          _createVNode(_component_router_link, {
                            "active-class": "is-active mt-3",
                            to: {name: 'Stats'}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Stats")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", {
                  class: "columns is-tp-person",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openUserMenu && _ctx.openUserMenu(...args)))
                }, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("figure", _hoisted_23, [
                      (_ctx.userImg)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "is-squircle",
                            src: _ctx.userImg,
                            alt: "User Image"
                          }, null, 8, _hoisted_24))
                        : (_openBlock(), _createElementBlock("img", _hoisted_25))
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_router_view, null, {
                  default: _withCtx(({ Component }) => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("footer", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("span", {
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openBeta && _ctx.openBeta(...args))),
                      class: "tag is-danger is-beta has-text-weight-semibold"
                    }, "Beta")
                  ]),
                  _hoisted_31
                ]),
                _hoisted_32
              ])
            ])
          ]),
          _createVNode(_Transition, {
            name: "modal",
            duration: 300,
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_ctx.showBeta)
                ? (_openBlock(), _createBlock(_component_beta, {
                    key: 0,
                    onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showBeta=false))
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, {
            name: "modal",
            duration: 300
          }, {
            default: _withCtx(() => [
              (_ctx.showUserMenu)
                ? (_openBlock(), _createBlock(_component_userModal, {
                    key: 0,
                    onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showUserMenu=false))
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, {
            name: "modal",
            duration: 300
          }, {
            default: _withCtx(() => [
              (_ctx.showNavigationMenu)
                ? (_openBlock(), _createBlock(_component_navigation_modal, {
                    key: 0,
                    onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showNavigationMenu=false)),
                    onOpenUserMenu: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openUserMenu()))
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 64))
      : (_openBlock(), _createBlock(_component_lazy, { key: 1 }))
  ]))
}